export const INSTITUTION = "JS_INSTITUTION";
export const INDICATOR = "JS_INDICATOR";
